import axios from '@/axios.js'

export default {
  fetchDataListItems ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/productcategory/data')
        .then((response) => {
          commit('SET_PRODUCTCATEGORIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/productcategory/update', {item})
        .then((response) => {
          commit('UPDATE_PRODUCTCATEGORIES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/productcategory/create', {item})
        .then((response) => {
          commit('CREATE_PRODUCTCATEGORIES', Object.assign(response.data.data, {id: response.data.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
